module.exports = __webpack_public_path__ + "img/file.b4bb1bde.svg";